var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { colors, cssVarsThemed } from '@creditornot/cb-ingredients';
import { createCssVars } from '@creditornot/cb-utils';
import DrawerOpenIcon from './DrawerOpenIcon';
import FileDashIcon from './FileDashIcon';
import FileEmptyIcon from './FileEmptyIcon';
import FileTextIcon from './FileTextIcon';
import FolderOpenIcon from './FolderOpenIcon';
var colorCssVars = createCssVars(['background', 'iconFill']);
var Root = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  width: 64px;\n  height: 64px;\n  border-radius: 32px;\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  svg {\n    width: 44%;\n    fill: ", ";\n  }\n"], ["\n  ", "\n\n  width: 64px;\n  height: 64px;\n  border-radius: 32px;\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  svg {\n    width: 44%;\n    fill: ", ";\n  }\n"])), cssVarsThemed({
    background: {
        light: colors.pepper8,
        dark: colors.salt8,
    },
    iconFill: {
        light: colors.pepper40,
        dark: colors.salt48,
    },
}), colorCssVars.background, colorCssVars.iconFill);
export var Folder = function (props) { return (React.createElement(Root, __assign({}, props),
    React.createElement(FolderOpenIcon, null))); };
export var Drawer = function (props) { return (React.createElement(Root, __assign({}, props),
    React.createElement(DrawerOpenIcon, null))); };
export var FileDash = function (props) { return (React.createElement(Root, __assign({}, props),
    React.createElement(FileDashIcon, null))); };
export var FileText = function (props) { return (React.createElement(Root, __assign({}, props),
    React.createElement(FileTextIcon, null))); };
export var FileEmpty = function (props) { return (React.createElement(Root, __assign({}, props),
    React.createElement(FileEmptyIcon, null))); };
var templateObject_1;
//# sourceMappingURL=EmptyIcon.js.map